import { isArray, isObject } from 'underscore';
import unescape from './helpers/unescape';
import adaptTranslationObjectKeys from './helpers/adapt_translation_object_keys';

const translations = {};

// Interpolates any placeholder with arguments in order
const interpolateByPosition = (string, ...rest) => (
  rest.reduce((accum, value) => (
    accum.replace(/%?{[A-Za-z0-9_-]+}/, value)
  ), string)
);

// Interpolates placeholders wby object keys
const interpolateByKey = (string, obj) => (
  Object.keys(obj).reduce((accum, key) => (
    accum.replace(new RegExp(`%?\\{${key}\\}`, 'g'), obj[key])
  ), string)
);

export const bulkAdd = (toAdd) => { Object.assign(translations, toAdd); };

export const translate = (key, ...rest) => {
  // BvApi.t receives an object, while $.t was receiving an array.
  // $.t.format functions support both and will convert to array if an object is received
  // Interpolation strings are now supported, example: "My name is %{lastname} %{firstname}."

  const options = isObject(rest[rest.length - 1]) && !isArray(rest[rest.length - 1])
    ? rest[rest.length - 1]
    : null;

  if (!(key in translations)) return (options && options.default) ? options.default : key;

  const translation = translations[key];

  if (typeof translation === 'function') {
    return unescape(translation(...(options ? Object.values(options) : rest)));
  }

  /* Some strings are directly set as "a: {0}, b: {1}" in tolk instead of using %{string}
  interpolation. These strings recieved here should be interpolated by position */
  if (translation.includes('{0}')) {
    return unescape(interpolateByPosition(
      translation, ...(options ? Object.values(options) : rest),
    ));
  }

  if (translation.match(/%{[A-Za-z0-9_-]+\}/g)) {
    if (options) {
      return unescape(interpolateByKey(translation, adaptTranslationObjectKeys(options)));
    }
    if (isArray(rest[rest.length - 1])) {
      return unescape(interpolateByPosition(translation, ...rest[rest.length - 1]));
    }
    return unescape(interpolateByPosition(translation, ...rest));
  }

  return unescape(translation);
};

export const exist = (key) => !!translations[key];

// Receives a string and returns a function
// Used by locale-fallback when generate JS file fails to load
export const interpolate = (string) => (...args) => interpolateByKey(string, { ...args });
